import { createI18nText } from '@hilma/netina2all';

const distStationsText = createI18nText({
    he: {
        title: 'תחנות חלוקה',
        info: <><br />
            שעות החלוקה משתנות בין תחנה לתחנה ומופיעות במפה. <br />
            שימו לב – המוצרים מגיעים באריזה סגורה ולכן לא ניתן לבחור מוצר בתחנות החלוקה.</>,
        toTheRest: 'לרשימת כל תחנות החלוקה',
        openDist: 'פתיחת תחנת חלוקה',
        window: {
            closed4more: 'התחנה סגורה להזמנות נוספות',
            area: 'אזור',
            address: 'כתובת',
            directions: 'הוראות הגעה',
            contactName: 'שם איש הקשר',
            contactNumber: 'טלפון איש הקשר',
            hours: 'שעות פעילות',
            accessible: 'נגישות לנכים',
            closed: 'התחנה סגורה',
            appt: '(בתיאום מראש)',
            yes: 'כן',
            no: 'לא',
        },
        on: 'ב',
        andOn: 'וב',
        day: 'יום',
        0: 'ראשון',
        1: 'שני',
        2: 'שלישי',
        3: 'רביעי',
        4: 'חמישי',
        5: 'שישי',
        6: 'שבת',
        satNight: 'מוצאי שבת',
        infoStart: 'תחנות החלוקה המפורטות להלן יהיו פתוחות ',
        infoEnd: ' שלפני פורים. '
    },
    en: {
        title: 'Distribution Stations',
        info: <><br />
            The distribution hours vary from station to station and appear on the map.<br />
            Please note - the products come in a sealed package, so you can not choose a product at the distribution stations.</>,
        toTheRest: 'To the full list of distribution stations',
        openDist: 'Open a distribution station',
        window: {
            closed4more: 'The station is closed to additional orders',
            area: 'Area',
            address: 'Address',
            directions: 'Directions',
            contactName: "Station Manager's Name",
            contactNumber: "Station Manager's Number",
            hours: 'Opening Hours',
            accessible: 'Accessibility',
            closed: 'Closed',
            appt: '(By appointment only)',
            yes: 'Yes',
            no: 'No'
        },
        on: 'on',
        andOn: 'and on',
        day: '', // supposed to be this way :)
        0: 'Sunday,',
        1: 'Monday,',
        2: 'Tuesday,',
        3: 'Wednesday,',
        4: 'Thursday,',
        5: 'Friday,',
        6: 'Saturday,',
        satNight: " Motza'ei Shabbat,",
        infoStart: 'The distribution stations listed below will be open',
        infoEnd: ' before Purim.'
    },
});

export default distStationsText;